import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Img from '../../../../Img';
import PopupV2 from '../../../../Popup/PopupV2';
import styles from '../../collegeProspectTab.scss';

const TESTID_PREFIX = 'modal.target-college-list-info';

const titleRowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
};

const titleIconStyle = {
    width: '18px',
    height: '18px',
    flexShrink: 0,
};

const actionsRowStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
};

const closeButtonStyle = {
    background: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '999px',
    padding: '10px 36px',
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '1px',
    cursor: 'pointer',
};

const TargetCollegeListInfoModal = ({ onClose }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleEsc);
        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
    }, [onClose]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [onClose]);

    return (
        <PopupV2
            onCloseClick={onClose}
            config={{
                size: 'fullScreenOnMobile',
                customWidth: 400,
                customHeader: () => null,
            }}
        >
            <div
                ref={modalRef}
                className={styles.targetCollegeListInfoModal}
                data-testid={`${TESTID_PREFIX}.container`}
            >
                <div className={styles.modalTitleRow} style={titleRowStyle}>
                    <Img
                        src="/img/v4/info-icon.svg"
                        alt=""
                        className={styles.modalTitleIcon}
                        style={titleIconStyle}
                    />
                    <div
                        className={styles.modalTitle}
                        data-testid={`${TESTID_PREFIX}.title`}
                    >
                        About Your Target College List
                    </div>
                </div>
                <div
                    className={styles.modalContent}
                    data-testid={`${TESTID_PREFIX}.body`}
                >
                    <p>
                        Your Target College List is where you save schools you&apos;re interested in. Track team strength, compare programs, and signal interest to coaches — all in one place.
                    </p>
                    <ul>
                        <li>
                            <strong>P6 (Power 6):</strong> Sums the verified UTRs of a team&apos;s top six players to estimate overall team strength (higher = stronger team).
                        </li>
                        <li>
                            <strong>Division:</strong> The level of competition, governed by the NCAA (D1, D2, D3), NAIA (smaller colleges), or NJCAA (junior colleges).
                        </li>
                        <li>
                            <strong>Conference:</strong> A group of colleges within a division that compete against each other regularly (e.g., SEC, ACC, Ivy League).
                        </li>
                        <li>
                            <strong>Alert Colleges:</strong> Turn this on to let the coach know you&apos;re interested. Your profile will appear on their recruiting dashboard so they can find you and reach out.
                        </li>
                    </ul>
                </div>
                <div className={styles.modalActions} style={actionsRowStyle}>
                    <button
                        type="button"
                        className={styles.closeButton}
                        style={closeButtonStyle}
                        onClick={onClose}
                        data-testid={`${TESTID_PREFIX}.close-btn`}
                    >
                        CLOSE
                    </button>
                </div>
            </div>
        </PopupV2>
    );
};

TargetCollegeListInfoModal.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default TargetCollegeListInfoModal;
